var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer" },
    [
      _vm.years.length
        ? _c("tenders-stat-table", {
            ref: "table",
            attrs: {
              type: "customers",
              years: _vm.years.slice().reverse(),
              stat: _vm.stat,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stat && _vm.productsStat && _vm.years.length
        ? _c("tenders-tile-charts", {
            attrs: {
              years: _vm.years,
              stat: _vm.stat,
              productsStat: _vm.productsStat,
              type: "customers",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }